import React from 'react';
import { Form, Input, DatePicker, Select, Button, Row, Col, Typography } from 'antd';
import moment from 'moment';

const { Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const DSRReportForm = ({ reportType, onCancel, onSubmit }) => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    onSubmit({
      ...values,
      reportType,
      date: values.date.format('YYYY-MM-DD'),
    });
  };

  const getReportTypeTitle = () => {
    const titles = {
      calendar: 'Calendar Day Report',
      shipping: 'Shipping Report',
      night: 'Night Shift Report',
      chassis: 'Chassis Report',
      weather: 'Weather Report',
    };
    return titles[reportType] || 'DSR Report';
  };

  return (
    <div className="dsr-report-form">
      <Title level={3}>{getReportTypeTitle()}</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          date: moment(),
          shift: 'day',
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="date"
              label="Date"
              rules={[{ required: true, message: 'Please select date' }]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="shift"
              label="Shift"
              rules={[{ required: true, message: 'Please select shift' }]}
            >
              <Select>
                <Option value="day">Day Shift</Option>
                <Option value="night">Night Shift</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="location"
          label="Location"
          rules={[{ required: true, message: 'Please enter location' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: 'Please enter description' }]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item name="issues" label="Issues/Concerns">
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item>
          <Row gutter={16}>
            <Col>
              <Button type="primary" htmlType="submit">
                Submit Report
              </Button>
            </Col>
            <Col>
              <Button onClick={onCancel}>Cancel</Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </div>
  );
};

export default DSRReportForm;
